import { Component, OnInit, Input, ViewChild, HostBinding, AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { DragScrollComponent } from 'ngx-drag-scroll';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  AnimationBuilder,
  AnimationPlayer
} from '@angular/animations';

enum animationStates {
  right = 'right',
  left = 'left',
  paused = 'paused',
  afterPause = 'afterPause'
}

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit, AfterViewInit {
  @ViewChild('scroll', { read: DragScrollComponent }) dsComponent: DragScrollComponent;
  @ViewChild('scroll', { read: ElementRef }) ds: ElementRef;
  @ViewChild('stats') stats: ElementRef;
  @Input() title: string;
  @Input() height: string;
  @Input() animationDuration: number = 10; //in seconds


  scrollContainer;
  scrollDirectionRight: boolean = true;
  scrollContainerWidth: number;
  scrollContainerScrollWidth: number;
  pause: boolean = false;
  fps: number = 15;
  fpsInterval: number;
  startTime: number;
  now: number;
  then: number;
  elapsed: number;

  constructor(
    private cdref: ChangeDetectorRef,
    private animBuilder: AnimationBuilder) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.scrollContainer = this.ds.nativeElement.querySelector('.drag-scroll-content');
    this.scrollContainerWidth = this.scrollContainer.getBoundingClientRect().width;
    this.scrollContainerScrollWidth = this.scrollContainer.scrollWidth;

    this.fpsInterval = 1000/this.fps;
    this.then = Date.now();
    this.startTime = this.then;

    var ua = navigator.userAgent;
    var isDesktop = true;

    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      isDesktop = false;
    }

    if(isDesktop) {
      requestAnimationFrame(() => {
        this.animateScroll(1);
      });
    }

    this.cdref.detectChanges();
  }

  animateScroll(speed) {
    if (!this.pause) {

      this.now = Date.now();
      this.elapsed = this.now - this.then;

      if (this.elapsed > this.fpsInterval || this.fps == 0){

        this.then = this.now - (this.elapsed % this.fpsInterval);

        if (this.scrollDirectionRight) {
          this.scrollContainer.scrollLeft += speed;
        }
        else {
          this.scrollContainer.scrollLeft -= speed;
        }
        if (this.scrollContainer.scrollLeft >= (this.scrollContainerScrollWidth - this.scrollContainerWidth)) {
          this.scrollDirectionRight = false;
        }
        if (this.scrollContainer.scrollLeft <= 0) {
          this.scrollDirectionRight = true;
        }
      }
    }
    requestAnimationFrame(() => {
      this.animateScroll(speed);
    });
  }
  pauseAnimation() {
    this.pause = true;
  }
  restartAnimation() {
    setTimeout(() => {
      this.pause = false;
    }, 1500);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/stats/stats.component.ts